<template>
  <div class="container-fluid ps-0 pe-0 pt-3 pb-3 pt-lg-4 pb-lg-5 d-block sbg-2">
    <div class="container">
      <div class="row g-2 g-lg-4 border rounded bg-white m-0 m-lg-2 p-3">
        <div class="d-flex mt-0 justify-content-between align-items-center">
          <img
            class="mt-2"
            style="max-width: 300px"
            src="/images/home/tnu_logo.svg"
            alt=""
          />
          <button
            type="button"
            class="btn-close"
            aria-label="關閉本網頁"
            @click="close()"
          ></button>
        </div>
        <div
          class="container pt-4 pt-lg-3 pb-lg-5 mt-3 rounded d-flex flex-column justify-content-center"
        >
          <div class="col-12">
            <div
              class="d-flex flex-row justify-content-between pb-0 section-title mb-2 mb-lg-4"
            >
              <h2 class="fw-bold d-flex align-items-center rounded-top pt-2 pb-2">
                <i
                  aria-hidden="true"
                  class="fa-solid fa-fw fa-ellipsis-vertical text-primary me-2"
                ></i
                ><span class="text-dark font-1-2em fw-bold">{{
                  posts.title_translations_zh_tw
                }}</span>
              </h2>
            </div>
          </div>
          <div class="col-12">
            <p class="text-primary">
              {{ posts.subtitle_translations_zh_tw }} /
              {{ posts.postdate ? posts.postdate.substr(0, 10) : "" }} / 觀看次數：{{
                posts.visits
              }}
              次
            </p>
          </div>
          <div class="col-12" v-html="getlocalPhoto(posts.text_translations_zh_tw)"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get_posts_by_id } from "@/js/api.js";

export default {
  // eslint-disable-next-line
  name: "News",
  data() {
    return {
      posts: [],
    };
  },
  components: {},
  methods: {
    init() {
      this.getPosts();
    },
    //取得焦點新聞
    getPosts() {
      var bodyFormData = new FormData();
      bodyFormData.append("rowid", this.$route.params.rowid);
      get_posts_by_id(bodyFormData)
        .then((response) => {
          this.posts = response.data[0];
          // console.log("get_posts" + response);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getlocalPhoto(url) {
      return url.replace(/https:\/\/www\.tnu\.edu\.tw/g, "");
    },
    close() {
      window.close();
    },
  },
  mounted() {},
  created() {
    this.init();
  },
  watch: {
    $route() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
  },
};
</script>

<style scoped>
.sbg-2 {
  min-height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: bottom;
  background-attachment: fixed;
  background-image: url("/public/images/home/section_bg_2.jpg");
}
</style>
